'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localisedPath = localisedPath;
exports.localisedUrl = localisedUrl;
exports.localisedAction = localisedAction;
exports.localisedRoot = localisedRoot;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _localisedPaths = require('../../config/localisedPaths.json');

var _localisedPaths2 = _interopRequireDefault(_localisedPaths);

var _localisedPathOverrides = require('../../config/localisedPathOverrides.js');

var _localisedPathOverrides2 = _interopRequireDefault(_localisedPathOverrides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOverride = function getOverride(storeCode, marketLocale, name) {
  var _arr = [storeCode + '.' + marketLocale + '.' + name, storeCode + '.default.' + name, 'default.' + marketLocale + '.' + name, 'default.default.' + name];

  for (var _i = 0; _i < _arr.length; _i++) {
    var path = _arr[_i];
    if (_lodash2.default.get(_localisedPathOverrides2.default, path)) {
      return _lodash2.default.get(_localisedPathOverrides2.default, path);
    }
  }
  return null;
};

function determineStoreLocale(store, locale) {
  return store.locales.indexOf(locale) > -1 ? locale : store.defaultLocale;
}

function localisedPath(store, path, locale) {
  var localeSlug = determineStoreLocale(store, locale);
  var marketLocale = store.marketLocale[localeSlug];

  var override = getOverride(store.code, marketLocale, path);

  if (override) {
    return override({
      country: store.countryCode.toLowerCase(),
      language: localeSlug.toLowerCase(),
      locale: marketLocale.toLowerCase(),
      brand: store.siteName.toLowerCase()
    });
  }

  var localPath = _localisedPaths2.default[marketLocale] && _localisedPaths2.default[marketLocale][path] || _localisedPaths2.default.default[path];

  return '/' + localeSlug + '/' + localPath;
}

function localisedUrl(store, path, locale) {
  var _window$location = window.location,
      protocol = _window$location.protocol,
      host = _window$location.host;

  var localPath = localisedPath(store, path, locale);
  return protocol + '//' + host + localPath;
}

function localisedAction(store, path, locale) {
  var localeSlug = determineStoreLocale(store, locale);

  return '/' + localeSlug + '/store/' + path;
}

function localisedRoot(store, locale) {
  var localeSlug = determineStoreLocale(store, locale);

  return '/' + localeSlug;
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/localisedPaths.js
// module id = 22
// module chunks = 0